<section class="comp-approval-status">

  <div *ngIf="request&&request.showStatusOnPage&&!request.showStatusInDialog">
    <div *ngIf="approvalStatus&&approvalStatus.length>0">
      <app-data-table [columns]="approvalStatusColumns" [value]="approvalStatus" sortField="index" [sortOrder]="PrimeNgConfig.TableAscSortOrder"
                      [disableSearch]="true" [bodyTemplate]="bodyTemplate">
        <ng-template #bodyTemplate let-row="row" let-rowIndex="rowIndex" let-columns="columns">
          <tr>
            <td *ngFor="let col of columns" [ngSwitch]="col.field">
              <span class="p-column-title">{{col.header}}</span>
              <span class="p-cell">
                <div *ngSwitchCase="'index'">{{ rowIndex + 1 }}</div>
                <div *ngSwitchCase="'actionOn'">{{row[col.field] | date: Format.Time }}</div>
                <div *ngSwitchCase="'actionTaken'">{{row[col.field] | titleCase }}</div>
                <div *ngSwitchDefault>{{row[col.field]}}</div>
              </span>
            </td>
          </tr>
        </ng-template>
      </app-data-table>

    </div>
    <div *ngIf="!approvalStatus||(approvalStatus&&approvalStatus.length<=0)">
      Approval status of your transaction is not available yet. Please try again later.
    </div>
  </div>

  <p-dialog header="Approval Status" [(visible)]="showApprovalStatusDialog" [responsive]="true" modal="true" dismissableMask="true" appendTo="body"
            [style]="PrimeNgConfig.DialogStyle65">
    <div *ngIf="approvalStatus&&approvalStatus.length>0">
      <app-data-table [columns]="approvalStatusColumns" [value]="approvalStatus" sortField="index" [sortOrder]="PrimeNgConfig.TableAscSortOrder"
                      [disableSearch]="true" [bodyTemplate]="bodyTemplate">
        <ng-template #bodyTemplate let-row="row" let-rowIndex="rowIndex" let-columns="columns">
          <tr>
            <td *ngFor="let col of columns" [ngSwitch]="col.field">
              <span class="p-column-title">{{col.header}}</span>
              <span class="p-cell">
                <div *ngSwitchCase="'index'">{{ rowIndex + 1 }}</div>
                <div *ngSwitchCase="'actionOn'">{{row[col.field] | date: Format.Time }}</div>
                <div *ngSwitchCase="'actionTaken'">{{row[col.field] | titleCase }}</div>
                <div *ngSwitchDefault>{{row[col.field]}}</div>
              </span>
            </td>
          </tr>
        </ng-template>
      </app-data-table>
    </div>
    <div *ngIf="!approvalStatus||(approvalStatus&&approvalStatus.length<=0)">
      Approval status of your transaction is not available yet. Please try again later.
    </div>

  </p-dialog>
</section>
